import localforage from 'localforage';
import { persistReducer as persist, purgeStoredState } from 'redux-persist';

const config = {
  storage: localforage,
  keyPrefix: 'slab',
};
const keys = [];

export function purgePersisted() {
  keys.forEach((key) => {
    purgeStoredState({
      ...config,
      key,
    });
  });
}

export function persistReducer(
  { key, whitelist, migrate = undefined },
  reducer,
) {
  keys.push(key);
  return persist(
    {
      ...config,
      key,
      whitelist,
      migrate,
    },
    reducer,
  );
}
